module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point3_3-d0a5cd542ef2dfa3372c7fce5d896bda.jpg";